import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/shadcn/tabs';

import type { RequestTabId } from '../model/requestTabs';

export type RequestStatusTabsProps = {
  value: RequestTabId;
  onValueChange(next: RequestTabId): void;
  actionsCount: number;
};

export function RequestStatusTabs({ value, onValueChange, actionsCount }: RequestStatusTabsProps) {
  const tabBarValue = value === 'resolved' ? 'active' : value;

  return (
    <Tabs
      value={tabBarValue}
      onValueChange={(next) => onValueChange(next as RequestTabId)}
      className="gap-0"
    >
      <TabsList aria-label="Request status tabs" className="h-6 gap-0">
        <TabsTrigger
          value="active"
          className="h-5 gap-1 px-1.5 text-[11px] font-semibold data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground"
        >
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-green-700" />
          Open Requests
        </TabsTrigger>
        <TabsTrigger
          value="actions"
          className="h-5 gap-1 px-1.5 text-[11px] font-semibold data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground"
        >
          Actions
          {actionsCount > 0 ? (
            <span className="inline-flex h-[14px] min-w-[14px] items-center justify-center rounded-full bg-muted px-1 text-[9px] font-semibold tabular-nums leading-none text-muted-foreground">
              {actionsCount}
            </span>
          ) : null}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
